import Vue from "vue"
import VueRouter from "vue-router"
import Layout from "@/layout"
Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		component: Layout,
		redirect: "/home",
		children: [
			{
				path: "/home",
				name: "Home",
				component: () => import("@/views/product/home/index.vue"),
				meta: {
					title: "Home",
					index: 0,
				},
			},
			{
				path: "/identity",
				name: "identity",
				component: () => import("@/views/product/metaverse/identity.vue"),
				meta: {
					title: "identity",
					index: 1,
				},
			},
			{
				path: "/fictitious",
				name: "fictitious",
				component: () => import("@/views/product/metaverse/fictitious.vue"),
				meta: {
					title: "fictitious",
					index: 1,
				},
			},
			{
				path: "/activities",
				name: "activities",
				component: () => import("@/views/product/metaverse/activities.vue"),
				meta: {
					title: "activities",
					index: 1,
				},
			},
			{
				path: "/function",
				name: "function",
				component: () => import("@/views/product/category/function.vue"),
				meta: {
					title: "activities",
					index: 1,
				},
			},
			{
				path: "/geomancy",
				name: "geomancy",
				component: () => import("@/views/product/category/geomancy.vue"),
				meta: {
					title: "activities",
					index: 1,
				},
			},
			{
				path: "/cultural",
				name: "cultural",
				component: () => import("@/views/product/category/cultural.vue"),
				meta: {
					title: "cultural",
					index: 1,
				},
			},
			{
				path: "/pattern",
				name: "pattern",
				component: () => import("@/views/product/category/pattern.vue"),
				meta: {
					title: "cultural",
					index: 1,
				},
			},
			{
				path: "/material",
				name: "material",
				component: () => import("@/views/product/category/material.vue"),
				meta: {
					title: "material",
					index: 1,
				},
			},
			{
				path: "/scene",
				name: "scene",
				component: () => import("@/views/product/category/scene.vue"),
				meta: {
					title: "scene",
					index: 1,
				},
			},
			{
				path: "/inherit",
				name: "inherit",
				component: () => import("@/views/product/category/inherit.vue"),
				meta: {
					title: "inherit",
					index: 1,
				},
			},
			{
				path: "/chinese",
				name: "chinese",
				component: () => import("@/views/product/category/chinese.vue"),
				meta: {
					title: "chinese",
					index: 1,
				},
			},
			{
				path: "/word",
				name: "word",
				component: () => import("@/views/product/category/word.vue"),
				meta: {
					title: "word",
					index: 1,
				},
			},
			//在线搭配
			{
				path: "/information",
				name: "information",
				component: () => import("@/views/product/matching/information.vue"),
				meta: {
					title: "information",
					index: 1,
				},
			},
			{
				path: "/match",
				name: "match",
				component: () => import("@/views/product/matching/match.vue"),
				meta: {
					title: "match",
					index: 1,
				},
			},
			{
				path: "/llig",
				name: "llig",
				component: () => import("@/views/product/matching/llig.vue"),
				meta: {
					title: "llig",
					index: 1,
				},
			},
			{
				path: "/tryon",
				name: "tryon",
				component: () => import("@/views/product/matching/tryon.vue"),
				meta: {
					title: "tryon",
					index: 1,
				},
			},
			//私人定制
			{
				path: "/creation",
				name: "creation",
				component: () => import("@/views/product/private/creation.vue"),
				meta: {
					title: "creation",
					index: 1,
				},
			},
			{
				path: "/gence",
				name: "gence",
				component: () => import("@/views/product/private/gence.vue"),
				meta: {
					title: "gence",
					index: 1,
				},
			},
			{
				path: "/models",
				name: "models",
				component: () => import("@/views/product/private/models.vue"),
				meta: {
					title: "models",
					index: 1,
				},
			},
			{
				path: "/trade",
				name: "trade",
				component: () => import("@/views/product/private/trade.vue"),
				meta: {
					title: "trade",
					index: 1,
				},
			},
			{
				path: "/loss",
				name: "loss",
				component: () => import("@/views/product/private/loss.vue"),
				meta: {
					title: "loss",
					index: 1,
				},
			},
			{
				path: "/routine",
				name: "routine",
				component: () => import("@/views/product/maintenance/routine.vue"),
				meta: {
					title: "routine",
					index: 1,
				},
			},
			{
				path: "/oldstuff",
				name: "oldstuff",
				component: () => import("@/views/product/maintenance/oldstuff.vue"),
				meta: {
					title: "oldstuff",
					index: 1,
				},
			},
			{
				path: "/damage",
				name: "damage",
				component: () => import("@/views/product/maintenance/damage.vue"),
				meta: {
					title: "damage",
					index: 1,
				},
			},

			{
				path: "/secondary",
				name: "secondary",
				component: () => import("@/views/product/maintenance/secondary.vue"),
				meta: {
					title: "secondary",
					index: 1,
				},
			},
			{
				path: "/evaluation",
				name: "evaluation",
				component: () => import("@/views/product/recycling/evaluation.vue"),
				meta: {
					title: "evaluation",
					index: 1,
				},
			},
			{
				path: "/value",
				name: "value",
				component: () => import("@/views/product/recycling/value.vue"),
				meta: {
					title: "value",
					index: 1,
				},
			},
			{
				path: "/appraisal",
				name: "appraisal",
				component: () => import("@/views/product/recycling/appraisal.vue"),
				meta: {
					title: "appraisal",
					index: 1,
				},
			},
			{
				path: "/recycle",
				name: "recycle",
				component: () => import("@/views/product/recycling/recycle.vue"),
				meta: {
					title: "recycle",
					index: 1,
				},
			},

			{
				path: "/unused",
				name: "unused",
				component: () => import("@/views/product/lease/unused.vue"),
				meta: {
					title: "unused",
					index: 1,
				},
			},
			{
				path: "/mortgage",
				name: "mortgage",
				component: () => import("@/views/product/lease/mortgage.vue"),
				meta: {
					title: "mortgage",
					index: 1,
				},
			},
			{
				path: "/rent",
				name: "rent",
				component: () => import("@/views/product/lease/rent.vue"),
				meta: {
					title: "rent",
					index: 1,
				},
			},
			{
				path: "/rental",
				name: "rental",
				component: () => import("@/views/product/lease/rental.vue"),
				meta: {
					title: "rent",
					index: 1,
				},
			},
			{
				path: "/cut",
				name: "cut",
				component: () => import("@/views/product/lease/cut.vue"),
				meta: {
					title: "cut",
					index: 1,
				},
			},
			{
				path: "/disinfect",
				name: "disinfect",
				component: () => import("@/views/product/lease/disinfect.vue"),
				meta: {
					title: "disinfect",
					index: 1,
				},
			},
			{
				path: "/regular",
				name: "regular",
				component: () => import("@/views/product/collect/regular.vue"),
				meta: {
					title: "regular",
					index: 1,
				},
			},
			{
				path: "/risk",
				name: "risk",
				component: () => import("@/views/product/collect/risk.vue"),
				meta: {
					title: "risk",
					index: 1,
				},
			},
			{
				path: "/knowledge",
				name: "knowledge",
				component: () => import("@/views/product/collect/knowledge.vue"),
				meta: {
					title: "knowledge",
					index: 1,
				},
			},
			{
				path: "/collection",
				name: "collection",
				component: () => import("@/views/product/collect/collection.vue"),
				meta: {
					title: "collection",
					index: 1,
				},
			},
			{
				path: "/property",
				name: "property",
				component: () => import("@/views/product/investment/property.vue"),
				meta: {
					title: "property",
					index: 1,
				},
			},
			{
				path: "/sell",
				name: "sell",
				component: () => import("@/views/product/investment/sell.vue"),
				meta: {
					title: "sell",
					index: 1,
				},
			},
			{
				path: "/analysis",
				name: "analysis",
				component: () => import("@/views/product/investment/analysis.vue"),
				meta: {
					title: "analysis",
					index: 1,
				},
			},
			{
				path: "/tax",
				name: "tax",
				component: () => import("@/views/product/investment/tax.vue"),
				meta: {
					title: "tax",
					index: 1,
				},
			},
			{
				path: "/points",
				name: "points",
				component: () => import("@/views/product/member/points.vue"),
				meta: {
					title: "points",
					index: 1,
				},
			},
			//专家鉴定
			{
				path: "/certification",
				name: "certification",
				component: () => import("@/views/product/expertise/certification.vue"),
				meta: {
					title: "certification",
					index: 1,
				},
			},
			{
				path: "/service",
				name: "service",
				component: () => import("@/views/product/expertise/service.vue"),
				meta: {
					title: "service",
					index: 1,
				},
			},
			//金融
			{
				path: "/means",
				name: "means",
				component: () => import("@/views/industry/finance/means.vue"),
				meta: {
					title: "means",
					index: 2,
				},
			},
			{
				path: "/interests",
				name: "interests",
				component: () => import("@/views/industry/finance/interests.vue"),
				meta: {
					title: "interests",
					index: 2,
				},
			},
			{
				path: "/fund",
				name: "fund",
				component: () => import("@/views/industry/finance/fund.vue"),
				meta: {
					title: "fund",
					index: 2,
				},
			},
			{
				path: "/consult",
				name: "consult",
				component: () => import("@/views/industry/finance/consult.vue"),
				meta: {
					title: "consult",
					index: 2,
				},
			},
			{
				path: "/pledge",
				name: "pledge",
				component: () => import("@/views/industry/finance/pledge.vue"),
				meta: {
					title: "pledge",
					index: 2,
				},
			},
			{
				path: "/stock",
				name: "stock",
				component: () => import("@/views/industry/finance/stock.vue"),
				meta: {
					title: "stock",
					index: 2,
				},
			},
			{
				path: "/claim",
				name: "claim",
				component: () => import("@/views/industry/finance/claim.vue"),
				meta: {
					title: "claim",
					index: 2,
				},
			},
			{
				path: "/danger",
				name: "danger",
				component: () => import("@/views/industry/finance/danger.vue"),
				meta: {
					title: "danger",
					index: 2,
				},
			},
			{
				path: "/price",
				name: "price",
				component: () => import("@/views/industry/finance/price.vue"),
				meta: {
					title: "price",
					index: 2,
				},
			},
			{
				path: "/opinion",
				name: "opinion",
				component: () => import("@/views/industry/finance/opinion.vue"),
				meta: {
					title: "opinion",
					index: 2,
				},
			},
			//安全交易
			{
				path: "/stages",
				name: "stages",
				component: () => import("@/views/product/secure/stages.vue"),
				meta: {
					title: "stages",
					index: 1,
				},
			},
			//其他
			{
				path: "/social",
				name: "social",
				component: () => import("@/views/product/other/social.vue"),
				meta: {
					title: "stages",
					index: 1,
				},
			},
			{
				path: "/competition",
				name: "competition",
				component: () => import("@/views/product/other/competition.vue"),
				meta: {
					title: "competition",
					index: 1,
				},
			},
			{
				path: "/promotions",
				name: "promotions",
				component: () => import("@/views/product/other/promotions.vue"),
				meta: {
					title: "promotions",
					index: 1,
				},
			},
			{
				path: "/headlines",
				name: "headlines",
				component: () => import("@/views/product/other/headlines.vue"),
				meta: {
					title: "headlines",
					index: 1,
				},
			},
			{
				path: "/feedback",
				name: "feedback",
				component: () => import("@/views/product/other/feedback.vue"),
				meta: {
					title: "feedback",
					index: 1,
				},
			},
			{
				path: "/customer",
				name: "customer",
				component: () => import("@/views/product/other/customer.vue"),
				meta: {
					title: "customer",
					index: 1,
				},
			},
			//政府
			{
				path: "/policy",
				name: "policy",
				component: () => import("@/views/industry/government/policy.vue"),
				meta: {
					title: "policy",
					index: 2,
				},
			},
			{
				path: "/resources",
				name: "resources",
				component: () => import("@/views/industry/government/resources.vue"),
				meta: {
					title: "resources",
					index: 2,
				},
			},
			{
				path: "/cooperation",
				name: "cooperation",
				component: () => import("@/views/industry/government/cooperation.vue"),
				meta: {
					title: "cooperation",
					index: 2,
				},
			},
			{
				path: "/summary",
				name: "summary",
				component: () => import("@/views/industry/government/summary.vue"),
				meta: {
					title: "summary",
					index: 2,
				},
			},
			//供应
			{
				path: "/minerals",
				name: "minerals",
				component: () => import("@/views/industry/supply/minerals.vue"),
				meta: {
					title: "minerals",
					index: 2,
				},
			},
			{
				path: "/process",
				name: "process",
				component: () => import("@/views/industry/supply/process.vue"),
				meta: {
					title: "process",
					index: 2,
				},
			},
			//研发
			{
				path: "/planning",
				name: "planning",
				component: () => import("@/views/industry/research/planning.vue"),
				meta: {
					title: "planning",
					index: 2,
				},
			},
			{
				path: "/ai",
				name: "ai",
				component: () => import("@/views/industry/research/ai.vue"),
				meta: {
					title: "ai",
					index: 2,
				},
			},
			{
				path: "/creattion",
				name: "creattion",
				component: () => import("@/views/industry/research/creattion.vue"),
				meta: {
					title: "creattion",
					index: 2,
				},
			},
			{
				path: "/digital",
				name: "digital",
				component: () => import("@/views/industry/research/digital.vue"),
				meta: {
					title: "digital",
					index: 2,
				},
			},
			{
				path: "/generation",
				name: "generation",
				component: () => import("@/views/industry/research/generation.vue"),
				meta: {
					title: "generation",
					index: 2,
				},
			},
			{
				path: "/device",
				name: "device",
				component: () => import("@/views/industry/produce/device.vue"),
				meta: {
					title: "device",
					index: 2,
				},
			},
			{
				path: "/mold",
				name: "mold",
				component: () => import("@/views/industry/produce/mold.vue"),
				meta: {
					title: "mold",
					index: 2,
				},
			},
			{
				path: "/materialw",
				name: "materialw",
				component: () => import("@/views/industry/produce/materialw.vue"),
				meta: {
					title: "materialw",
					index: 2,
				},
			},
			{
				path: "/innovate",
				name: "innovate",
				component: () => import("@/views/industry/produce/innovate.vue"),
				meta: {
					title: "innovate",
					index: 2,
				},
			},
			{
				path: "/fine",
				name: "fine",
				component: () => import("@/views/industry/produce/fine.vue"),
				meta: {
					title: "fine",
					index: 2,
				},
			},
			//批发
			{
				path: "/exhibition",
				name: "exhibition",
				component: () => import("@/views/industry/produce/exhibition.vue"),
				meta: {
					title: "exhibition",
					index: 2,
				},
			},
			//地产
			{
				path: "/business",
				name: "business",
				component: () => import("@/views/industry/property/business.vue"),
				meta: {
					title: "business",
					index: 2,
				},
			},
			{
				path: "/time",
				name: "time",
				component: () => import("@/views/industry/property/time.vue"),
				meta: {
					title: "time",
					index: 2,
				},
			},
			{
				path: "/traffic",
				name: "traffic",
				component: () => import("@/views/industry/property/traffic.vue"),
				meta: {
					title: "traffic",
					index: 2,
				},
			},
			{
				path: "/management",
				name: "management",
				component: () => import("@/views/industry/property/management.vue"),
				meta: {
					title: "management",
					index: 2,
				},
			},
			{
				path: "/area",
				name: "area",
				component: () => import("@/views/industry/property/area.vue"),
				meta: {
					title: "area",
					index: 2,
				},
			},
			{
				path: "/compete",
				name: "compete",
				component: () => import("@/views/industry/property/compete.vue"),
				meta: {
					title: "compete",
					index: 2,
				},
			},
			//装修
			{
				path: "/scheme",
				name: "scheme",
				component: () => import("@/views/industry/decoration/scheme.vue"),
				meta: {
					title: "scheme",
					index: 2,
				},
			},
			{
				path: "/construction",
				name: "construction",
				component: () => import("@/views/industry/decoration/construction.vue"),
				meta: {
					title: "construction",
					index: 2,
				},
			},
			{
				path: "/maintain",
				name: "maintain",
				component: () => import("@/views/industry/decoration/maintain.vue"),
				meta: {
					title: "maintain",
					index: 2,
				},
			},
			{
				path: "/materialq",
				name: "materialq",
				component: () => import("@/views/industry/decoration/materialq.vue"),
				meta: {
					title: "materialq",
					index: 2,
				},
			},
			//招募
			{
				path: "/authenticate",
				name: "authenticate",
				component: () => import("@/views/industry/recruit/authenticate.vue"),
				meta: {
					title: "authenticate",
					index: 2,
				},
			},
			{
				path: "/format",
				name: "format",
				component: () => import("@/views/industry/recruit/format.vue"),
				meta: {
					title: "format",
					index: 2,
				},
			},
			{
				path: "/research",
				name: "research",
				component: () => import("@/views/industry/recruit/research.vue"),
				meta: {
					title: "research",
					index: 2,
				},
			},
			{
				path: "/generate",
				name: "generate",
				component: () => import("@/views/industry/recruit/generate.vue"),
				meta: {
					title: "generate",
					index: 2,
				},
			},
			{
				path: "/marketing",
				name: "marketing",
				component: () => import("@/views/industry/recruit/marketing.vue"),
				meta: {
					title: "marketing",
					index: 2,
				},
			},
			{
				path: "/manage",
				name: "manage",
				component: () => import("@/views/industry/recruit/manage.vue"),
				meta: {
					title: "manage",
					index: 2,
				},
			},
			//培训
			{
				path: "/course",
				name: "course",
				component: () => import("@/views/industry/training/course.vue"),
				meta: {
					title: "course",
					index: 2,
				},
			},
			{
				path: "/practice",
				name: "practice",
				component: () => import("@/views/industry/training/practice.vue"),
				meta: {
					title: "practice",
					index: 2,
				},
			},
			{
				path: "/examine",
				name: "examine",
				component: () => import("@/views/industry/training/examine.vue"),
				meta: {
					title: "examine",
					index: 2,
				},
			},
			{
				path: "/motivate",
				name: "motivate",
				component: () => import("@/views/industry/training/motivate.vue"),
				meta: {
					title: "motivate",
					index: 2,
				},
			},
			{
				path: "/promotion",
				name: "promotion",
				component: () => import("@/views/industry/training/promotion.vue"),
				meta: {
					title: "promotion",
					index: 2,
				},
			},
			//存放
			{
				path: "/deposit",
				name: "deposit",
				component: () => import("@/views/industry/training/deposit.vue"),
				meta: {
					title: "deposit",
					index: 2,
				},
			},
			{
				path: "/blockchain",
				name: "blockchain",
				component: () => import("@/views/industry/training/blockchain.vue"),
				meta: {
					title: "blockchain",
					index: 2,
				},
			},
			//数据
			{
				path: "/company",
				name: "company",
				component: () => import("@/views/industry/data/company.vue"),
				meta: {
					title: "company",
					index: 2,
				},
			},
			{
				path: "/cooperate",
				name: "cooperate",
				component: () => import("@/views/industry/data/cooperate.vue"),
				meta: {
					title: "cooperate",
					index: 2,
				},
			},
			{
				path: "/prodata",
				name: "prodata",
				component: () => import("@/views/industry/data/prodata.vue"),
				meta: {
					title: "prodata",
					index: 2,
				},
			},
			{
				path: "/prodic",
				name: "prodic",
				component: () => import("@/views/industry/data/prodic.vue"),
				meta: {
					title: "prodic",
					index: 2,
				},
			},
			{
				path: "/user",
				name: "user",
				component: () => import("@/views/industry/data/user.vue"),
				meta: {
					title: "user",
					index: 2,
				},
			},
			{
				path: "/consumption",
				name: "consumption",
				component: () => import("@/views/industry/data/consumption.vue"),
				meta: {
					title: "consumption",
					index: 2,
				},
			},
			//其他
			{
				path: "/proposition",
				name: "proposition",
				component: () => import("@/views/industry/data/proposition.vue"),
				meta: {
					title: "proposition",
					index: 2,
				},
			},
			{
				path: "/operation",
				name: "operation",
				component: () => import("@/views/industry/data/operation.vue"),
				meta: {
					title: "operation",
					index: 2,
				},
			},
			{
				path: "/logistics",
				name: "logistics",
				component: () => import("@/views/industry/data/logistics.vue"),
				meta: {
					title: "logistics",
					index: 2,
				},
			},
			//解决方案
			{
				path: "/intelligent",
				name: "intelligent",
				component: () => import("@/views/solution/showcase/intelligent.vue"),
				meta: {
					title: "intelligent",
					index: 3,
				},
			},
			{
				path: "/introduce",
				name: "introduce",
				component: () => import("@/views/solution/showcase/introduce.vue"),
				meta: {
					title: "introduce",
					index: 3,
				},
			},
			{
				path: "/match",
				name: "match",
				component: () => import("@/views/solution/showcase/match.vue"),
				meta: {
					title: "match",
					index: 3,
				},
			},
			//广告
			{
				path: "/interactive",
				name: "interactive",
				component: () =>
					import("@/views/solution/advertisement/interactive.vue"),
				meta: {
					title: "match",
					index: 3,
				},
			},
			{
				path: "/launch",
				name: "launch",
				component: () => import("@/views/solution/advertisement/launch.vue"),
				meta: {
					title: "match",
					index: 3,
				},
			},
			{
				path: "/virtual",
				name: "virtual",
				component: () => import("@/views/solution/advertisement/virtual.vue"),
				meta: {
					title: "virtual",
					index: 3,
				},
			},
			//无人售卖
			{
				path: "/spot",
				name: "spot",
				component: () => import("@/views/solution/advertisement/spot.vue"),
				meta: {
					title: "spot",
					index: 3,
				},
			},
			{
				path: "/recyqwe",
				name: "recyqwe",
				component: () => import("@/views/solution/advertisement/recyqwe.vue"),
				meta: {
					title: "recyqwe",
					index: 3,
				},
			},
			{
				path: "/maintenance",
				name: "maintenance",
				component: () =>
					import("@/views/solution/advertisement/maintenance.vue"),
				meta: {
					title: "maintenance",
					index: 3,
				},
			},
			{
				path: "/advice",
				name: "advice",
				component: () => import("@/views/solution/advertisement/advice.vue"),
				meta: {
					title: "advice",
					index: 3,
				},
			},
			//footer
			{
				path: "/overview",
				name: "overview",
				component: () => import("@/views/footer/overview.vue"),
				meta: {
					title: "overview",
				},
			},
			{
				path: "/laboratory",
				name: "laboratory",
				component: () => import("@/views/footer/laboratory.vue"),
				meta: {
					title: "laboratory",
				},
			},
			{
				path: "/sustainable",
				name: "sustainable",
				component: () => import("@/views/footer/sustainable.vue"),
				meta: {
					title: "sustainable",
				},
			},
			{
				path: "/career",
				name: "career",
				component: () => import("@/views/footer/career.vue"),
				meta: {
					title: "career",
				},
			},
			{
				path: "/news",
				name: "news",
				component: () => import("@/views/footer/news.vue"),
				meta: {
					title: "news",
				},
			},
			{
				path: "/details",
				name: "details",
				component: () => import("@/views/footer/details.vue"),
				meta: {
					title: "details",
				},
			},
			{
				path: "/blog",
				name: "blog",
				component: () => import("@/views/footer/blog.vue"),
				meta: {
					title: "blog",
				},
			},
			{
				path: "/join",
				name: "join",
				component: () => import("@/views/footer/join.vue"),
				meta: {
					title: "join",
				},
			},
			{
				path: "/discuss",
				name: "discuss",
				component: () => import("@/views/footer/discuss.vue"),
				meta: {
					title: "discuss",
				},
			},
		],
	},
]

const router = new VueRouter({
	routes,
})

export default router
